import { SKIP_TURNSTILE } from '../config/features';

/** #128: alarme visível quando o build está com o Turnstile desligado. */
export default function TurnstileSkippedBanner() {
  if (!SKIP_TURNSTILE) return null;
  return (
    <div
      role="alert"
      className="fixed bottom-0 inset-x-0 z-[9999] bg-red-600 text-white text-xs text-center py-1"
    >
      Turnstile desligado (VITE_SKIP_TURNSTILE) — build de teste, não usar em produção
    </div>
  );
}
